import { AssociationFileBrowser } from "@/shared/components/AssociationFileBrowser";
import { Goto } from "@/shared/navigation";

import { useDeviceTypeContext } from "../DeviceType/useDeviceTypeContext";

/**
 * Configurations tab of a device type: the files stored on the type, which
 * every device of the type inherits, in a file browser that can change them.
 */
export function DeviceTypeConfigurations() {
  const { deviceType } = useDeviceTypeContext();

  return (
    <AssociationFileBrowser
      associationId={deviceType.device_type_id}
      orgId={deviceType.org_id}
      rootUrl={Goto.createAssociationRoute(deviceType.device_type_id)}
      rootLabel={deviceType.name}
      parentCrumbs={[]}
    />
  );
}
